import React from 'react';
import { Box, Typography, Stack, Chip, IconButton, Link } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

const GroupList = ({
    users,
    onUserClick,
    shouldEdit,
    shouldDelete,
    onDeleteClick,
}) => {
    return (
        <Box
            sx={{
                border: '1px solid #E0E0E0',
                borderRadius: '12px',
                marginTop: '16px',
                overflow: 'hidden',
            }}
        >
            {users.map((group, index) => (
                <Box
                    key={group.id}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        p: 2,
                        cursor: 'pointer',
                        borderBottom:
                            index !== users.length - 1
                                ? '1px solid #E0E0E0'
                                : 'none',
                        '&:hover': {
                            backgroundColor: '#f9f9f9',
                        },
                    }}
                    onClick={() => onUserClick(group)}
                >
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '16px',
                            fontWeight: '400',
                            color: '#292929',
                        }}
                    >
                        {group.name}
                    </Typography>

                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: '#666666',
                            mt: 1,
                        }}
                    >
                        {group.description || 'N/A'}
                    </Typography>
                    <Chip
                        label={group.gameName}
                        size="small"
                        color="primary"
                        sx={{ maxWidth: '90px' }}
                    />

                    <Typography variant="body2" sx={{ mt: 1 }}>
                        {group.users.length} jogador(es)
                    </Typography>

                    <Stack
                        direction="row"
                        spacing={2}
                        sx={{ mt: 2, justifyContent: 'start' }}
                    >
                        {shouldEdit && (
                            <Link
                                component="button"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onUserClick(group);
                                }}
                                underline="none"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#1F83FF',
                                }}
                            >
                                <EditOutlinedIcon fontSize="small" />
                                <Typography sx={{ ml: 0.5 }}>Editar</Typography>
                            </Link>
                        )}

                        {shouldDelete && (
                            <Link
                                component="button"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onDeleteClick(group);
                                }}
                                underline="none"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#1F83FF',
                                }}
                            >
                                <DeleteOutlinedIcon fontSize="small" />
                                <Typography sx={{ ml: 0.5 }}>
                                    Excluir
                                </Typography>
                            </Link>
                        )}
                    </Stack>
                </Box>
            ))}
        </Box>
    );
};

export default GroupList;
